module.exports = __webpack_public_path__ + "static/media/msg-fail.04465248.svg";